import { AxiosResponse } from 'axios';
import { call, put } from 'redux-saga/effects';
import api from '../../Axios/middleware';
import {
  failureGetDesignation,
  successGetDesignation,
} from './DesignationSlicer';
import { IDesignationList } from '../../../Pages/UserDesignation/IDesignation';
import { PayloadAction } from '@reduxjs/toolkit';
import {
  failureAddDesignation,
  successAddDesignation,
} from './AddDesignationSlicer';
import {
  failureUpdateDesignation,
  successUpdateDesignation,
} from './UpdateDesignationSlicer';
import {
  failureDeleteDesignation,
  successDeleteDesignation,
} from './DeleteDesignationSlice';
import { Phone } from '@mui/icons-material';

const DesignationApi = (action: PayloadAction<any>) => {
  return api.get(`/userDesignations/${action.payload}`);
};

export function* DesignationCall(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse = yield call(DesignationApi, action);
    yield put(successGetDesignation(response.data));
  } catch (error) {
    yield put(failureGetDesignation(error));
  }
}

// add Designation
const AddDesignationApi = (action: PayloadAction<IDesignationList>) => {
  const data = {
    name: action.payload.name,
    location_id: action.payload.location_id,
  };

  return api.post('/userDesignations/create', action.payload);
};

export function* AddDesignationCall(action: PayloadAction<IDesignationList>) {
  try {
    const response: AxiosResponse = yield call(AddDesignationApi, action);
    yield put(successAddDesignation(response.data));
  } catch (error) {
    yield put(failureAddDesignation(error));
  }
}

// update Designation
const UpdateDesignationApi = (action: PayloadAction<IDesignationList>) => {
  // const formData = new FormData();

  // Object.entries(action.payload).forEach(([key, value]) => {
  //   formData.append(key, value);
  // });

  const url = `/userDesignations/${action.payload.id}`;

  return api.patch(url, action.payload);
};

export function* UpdateDesignationCall(
  action: PayloadAction<IDesignationList>
) {
  try {
    const response: AxiosResponse = yield call(UpdateDesignationApi, action);
    yield put(successUpdateDesignation(response.data));
  } catch (error) {
    yield put(failureUpdateDesignation(error));
  }
}

// delete Designation
const DeleteDesignationApi = (action: PayloadAction<number>) => {
  return api.delete(`/userDesignations/${action.payload}`);
};
export function* DeleteDesignationCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteDesignationApi, action);
    yield put(successDeleteDesignation(response.data));
  } catch (error) {
    yield put(failureDeleteDesignation(error));
  }
}
